<template>
 <PageSpinner :onloader="onloader" />
</template>
<script>
import PageSpinner from "@/components/PageSpinner";
export default {
  name: "InternetAlert",
  components: {
    PageSpinner
  },
  data() {
    return {
      onLine: navigator.onLine,
      showBackOnline: false,
      overlay: "none",
       onloader: "none",
    };
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";     
      this.showBackOnline = false;
      if (this.onLine == true) {
        this.overlay = "none";
      }
      if (this.onLine == false) {
        this.overlay = "flex";
      }
    },
  },
  watch: {
    onLine(v) {
      if (v) {
        this.showBackOnline = true;
        setTimeout(() => {}, 100);
      }
    },
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
};
</script>
